import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PrintIcon from '@mui/icons-material/Print';
import { getSelfReceiptSettings, setSelfReceiptSettings } from '../../selfReceiptShareUtils';

// Receipt print + share preferences for the self-order kiosk.
// Persisted in localStorage and read by the receipt view (SelfFeedback).
const SelfReceiptSettings = () => {
  const [settings, setSettings] = useState(getSelfReceiptSettings());

  const update = (key) => (e) => {
    const next = { ...settings, [key]: e.target.checked };
    setSettings(next);
    setSelfReceiptSettings(next);
  };

  return (
    <Accordion sx={{ width: '100%', mt: 2, boxShadow: 'none', border: '1px solid #e0e0e0' }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <PrintIcon fontSize="small" sx={{ mr: 1, color: '#666' }} />
        <Typography variant="subtitle2">Receipt Print & Share</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormGroup>
          <Typography variant="caption" color="text.secondary">Printer</Typography>
          <FormControlLabel
            control={<Checkbox size="small" checked={settings.autoPrint} onChange={update('autoPrint')} />}
            label="Auto-print receipt (device printer)"
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            Printer is chosen from the device print dialog.
          </Typography>

          <Divider sx={{ my: 1 }} />

          <Typography variant="caption" color="text.secondary">Auto-share on Share</Typography>
          <FormControlLabel
            control={<Checkbox size="small" checked={settings.whatsapp} onChange={update('whatsapp')} />}
            label="WhatsApp"
          />
          <FormControlLabel
            control={<Checkbox size="small" checked={settings.sms} onChange={update('sms')} />}
            label="SMS"
          />
          <FormControlLabel
            control={<Checkbox size="small" checked={settings.email} onChange={update('email')} />}
            label="Email"
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
            If the channel/contact isn't available, the device share options open instead.
          </Typography>
        </FormGroup>
      </AccordionDetails>
    </Accordion>
  );
};

export default SelfReceiptSettings;
